enum FeatureFlags {
  PARTICIPANT_RECRUITMENT = 'PARTICIPANT_RECRUITMENT',
  GENETIC_COUNSELING = 'GENETIC_COUNSELING',
  CAMPAIGN_TRACKING = 'CAMPAIGN_TRACKING',
  BUCCAL_SAMPLE_TYPE = 'BUCCAL_SAMPLE_TYPE',
  NO_SHOW_REVAMP = 'NO_SHOW_REVAMP',
}

export default FeatureFlags;
